import { getCalculatorRouteLeadersOrder, defaultCalculatorResultLeadersLimit } from '../../lib/userApi';

export const defaultLeadersOrder = (_state, { currentRoute }) =>
  getCalculatorRouteLeadersOrder(currentRoute);

export const leadersOrder = (state, { currentRoute }) => {
  const defaultOrder = getCalculatorRouteLeadersOrder(currentRoute);
  const { orderField, orderDesc } = state.leaders.filter;
  let order = orderField || defaultOrder;
  if (orderDesc) {
    order = `-${order}`;
  }
  return order;
};

const emptyQueryResult = {
  totalPages: 0,
  nextPage: -1,
  currentPage: 0,
  pages: { 0: [] },
};

export const leadersQueryResult = (state, { currentRoute }) => {
  const order = leadersOrder(state, { currentRoute });
  return state.leaders.queriesByOrder[order] || emptyQueryResult;
};

export const calculatorResultLeaders = (state, { currentRoute }) => {
  const order = leadersOrder(state, { currentRoute });
  const queryForOrder = state.leaders.queriesByOrder[order];
  if (!queryForOrder) return [];
  return queryForOrder.pages[queryForOrder.currentPage] || [];
};

export const calculatorResultLeadersOffset = (state, { currentRoute }) => {
  const order = leadersOrder(state, { currentRoute });
  const queryForOrder = state.leaders.queriesByOrder[order];
  if (!queryForOrder) return 0;
  return (queryForOrder.currentPage - 1) * defaultCalculatorResultLeadersLimit;
};

export const leadersFilter = state => state.leaders.filter;
export const leadersFilterForm = state => state.leaders.filterForm;

export const modalLeader = state => state.ui.modalLeader;
